
export default {
  name: 'withdrawal',
  components: {

  },
  data() {
    return {
      list: [],
      ruleForm: {
        bid: '',
        money: ''
      },
      rules: {
        money: [
          { required: true, message: '请输入提现金额', trigger: 'blur' }
        ]
      },
      maxMoney: '',
      userInfo: {},
      bid: '',
      total_withdrawal: '',
      validmoney: '',
      shows: false,
      showMsg: '',
      codeImg: ''
    }
  },
  created() {
  },
  mounted: function () {
    this.bid = this.$route.query.bid
    this.init()
  },
  methods: {

    toLists: function() {
      this.$router.push({ path: '/accountList' })
    },
    init: function () {
      setTimeout(d => {
        this.getList()
        this.getInfo()
      })
      if (this.$route.query.bid) {
        this.ruleForm.bid = this.$route.query.bid
        this.total_withdrawal = this.$route.query.total_withdrawal
        this.validmoney = this.$route.query.validmoney
        this.$forceUpdate()
      } else {

      }
    },
    changeData: function(e) {
      this.list.forEach(d => {
        if (d.b_id == e) {
          this.total_withdrawal = d.total_withdrawal
          this.validmoney = d.validmoney
          this.$forceUpdate()
        }
      })
    },
    getInfo: function () {
      this.apiGet('/h5/api/user/getUserInfo', '', res => {
        if (res.state) {
          this.userInfo = res.data

          this.$forceUpdate()
        } else {
        }
      })
    },
    getList: function () {
      this.apiGet('/h5/api/user/account/getList', '', res => {
        if (res.state) {
          this.list = res.data || []
          let datas = res.data || []
          if (datas.length) {
            if (!this.bid) {
              this.ruleForm.bid = datas[0]['b_id']
              this.total_withdrawal = datas[0].total_withdrawal
              this.validmoney = datas[0].validmoney
            }
          } else {
            this.$message('没有可提现账户')
          }
        } else {
          this.$message(res.msg)
        }
      })
    },
    getAll: function() {
      this.ruleForm.money = this.validmoney
    },
    save() {
      if (!this.ruleForm.money) {
        this.$message('请输入提现金额')
        return
      }
      console.log(this.ruleForm.money, this.validmoney)
      if (Number(this.ruleForm.money) > Number(this.validmoney)) {
        this.$message('提现金额不能大于可提现金额')
        return
      }
      this.apiGet('/h5/api/user/withdrawal/postData', this.ruleForm, res => {
        if (res.state) {
          // this.$message({
          //   message: res.msg,
          //   type: 'success'
          // });
          // this.validmoney = Number(this.validmoney)-Number(this.ruleForm.money);
          this.$alert(`<div style="font-size:18px;line-height:30px;color:red;">${res.msg}</div>`, '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: action => {
              this.$router.replace({
                path: '/accountList', query: {}
              })
            }
          })
          setTimeout(d => {
            this.init()
          }, 1500)
        } else {
          // this.$message(res.msg);
          // if(res.code!='40008'){
          //   this.showMsg = res.msg;
          // }else{
          //   let data = res.msg.split("：");
          //   this.showMsg=data[0];
          //   this.codeImg = data[1];
          // }

          if (res.msg.indexOf('请联系客服微信') != '-1') {
            let data = res.msg.split('：')
            this.showMsg = data[0]
            this.codeImg = data[1]
          } else {
            this.showMsg = res.msg
          }

          this.shows = true
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },

    toHb: function () {
      this.$message('正在开发')
    },
    toLinks: function () {
      this.$router.push({ path: '/links' })
    },

    toMy: function () {
      this.$router.push({ path: '/my' })
    },
    toHome: function () {
      this.$router.push({ path: '/home' })
    },
    toBindAli: function () {
      this.$router.push({ path: '/bindAli' })
    },

    toList: function () {
      this.$router.push({ path: '/list' })
    },
    toWithdrawal: function () {
      this.$router.push({ path: '/userWithdrawalRecord?bId=' + this.bid })
    },
    backPage: function () {
      window.history.go(-1)
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/withdrawal/withdrawal.js